import React, { useEffect } from 'react';
import Animated, {
    useAnimatedStyle,
    useSharedValue,
    withDelay,
    withRepeat,
    withSequence,
    withTiming,
} from 'react-native-reanimated';
import { CHAT_SKELETON } from '../../constants';
import type { TChatLoadingDotProps } from '../../types';

export const ChatLoadingDot = ({ index }: TChatLoadingDotProps) => {
    const { stepMs, onMs, offMs, minOpacity } = CHAT_SKELETON.dot;
    const opacity = useSharedValue<number>(minOpacity);
    useEffect(() => {
        opacity.value = withDelay(
            index * stepMs,
            withRepeat(withSequence(withTiming(1, { duration: onMs }), withTiming(minOpacity, { duration: offMs })), -1),
        );
    }, [index, opacity, stepMs, onMs, offMs, minOpacity]);
    const style = useAnimatedStyle(() => ({ opacity: opacity.value }));
    return <Animated.View style={style} className="w-1.5 h-1.5 rounded-full bg-secondary-600" />;
};
